/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createAddAdminUserResponseFromDiscriminatorValue, createDeleteAdminUserResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOrganizationUserFromDiscriminatorValue, serializeAddAdminUserRequest, serializeAddAdminUserResponse, serializeDeleteAdminUserRequest, serializeDeleteAdminUserResponse, type AddAdminUserRequest, type AddAdminUserResponse, type DeleteAdminUserRequest, type DeleteAdminUserResponse, type ErrorResponse, type InternalErrorResponse, type OrganizationUser } from '../../../../models/index.js';
// @ts-ignore
import { ResendWelcomeRequestBuilderRequestsMetadata, type ResendWelcomeRequestBuilder } from './resendWelcome/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/users/admins
 */
export interface AdminsRequestBuilder extends BaseRequestBuilder<AdminsRequestBuilder> {
    /**
     * The resendWelcome property
     */
    get resendWelcome(): ResendWelcomeRequestBuilder;
    /**
     * Removes the admin role from a user in the organization
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DeleteAdminUserResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(body: DeleteAdminUserRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DeleteAdminUserResponse | undefined>;
    /**
     * List all admin users for an organization with their roles
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OrganizationUser[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 409 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<OrganizationUser[] | undefined>;
    /**
     * Assigns the admin role to a user in the organization
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<AddAdminUserResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: AddAdminUserRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<AddAdminUserResponse | undefined>;
    /**
     * Removes the admin role from a user in the organization
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: DeleteAdminUserRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * List all admin users for an organization with their roles
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Assigns the admin role to a user in the organization
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AddAdminUserRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const AdminsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/users/admins";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AdminsRequestBuilderNavigationMetadata: Record<Exclude<keyof AdminsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    resendWelcome: {
        requestsMetadata: ResendWelcomeRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const AdminsRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: AdminsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDeleteAdminUserResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeleteAdminUserRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    get: {
        uriTemplate: AdminsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createOrganizationUserFromDiscriminatorValue,
    },
    post: {
        uriTemplate: AdminsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createAddAdminUserResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAddAdminUserRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
